import { render, staticRenderFns } from "./GenericListItem.vue?vue&type=template&id=472d46e1&scoped=true"
import script from "./GenericListItem.vue?vue&type=script&lang=ts"
export * from "./GenericListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d46e1",
  null
  
)

export default component.exports